import { useCallback, useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { useHistory } from "react-router-dom"
import { get_rain_form_data, rain_api } from "./api"

export const useRainApi = (type: string, next: string | VoidFunction) => {
  const { control, handleSubmit, reset, ...formModel } = useForm()
  const navigate = useHistory()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const formData = get_rain_form_data(type)
    reset(formData)
    return () => {
      reset(
        {
          first_name: "",
          last_name: "",
          mail: "",
          person_national_id: "",
          address: "",
          city: "",
          state: "",
          zip: "",
          id_type: "",
        },
        {
          keepDefaultValues: false,
          keepValues: false,
        },
      )
    }
  }, [type, reset])
  const onSubmit = useCallback(
    async (data: unknown) => {
      setLoading(true)
      try {
        await rain_api(type, data)
      } catch {
      } finally {
        setLoading(false)
        if (typeof next !== "string") next()
        else {
          navigate.push(`${next}`)
        }
      }
    },
    [type, next, navigate],
  )
  return { loading, onSubmit, control, handleSubmit, formModel, reset }
}
